<div class="overlay-loader" *ngIf="showLoader">
	<div class="overlay-content">
		<mat-spinner [diameter]="30" color="secondary"></mat-spinner>
	</div>
</div>